import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoElem = _resolveComponent("LogoElem")!
  const _component_NavbarSection = _resolveComponent("NavbarSection")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["nav-inner glass-tile", {
                'page-scrolled': _ctx.isWindowScrolled,
                'nav-expand': _ctx.isNavExpand
            }]),
      ref: "innerNav",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleNav && _ctx.toggleNav(...args))),
      onMousemove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navHoverBorder && _ctx.navHoverBorder(...args)))
    }, [
      _createElementVNode("div", {
        class: "nav-logo",
        ref: "navCloseBtn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navLogoScroll && _ctx.navLogoScroll(...args)))
      }, [
        _createVNode(_component_LogoElem)
      ], 512),
      _createVNode(_component_NavbarSection)
    ], 34)
  ]))
}